import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO_OVAL } from "../data/films";

const LINKS = [
    { id: "peliculas", label: "Películas", num: "01" },
    { id: "nosotros", label: "Nosotros", num: "02" },
    { id: "galeria", label: "Galería", num: "03" },
    { id: "contacto", label: "Contacto", num: "04" },
];

export default function Nav({ scrollTo }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        scrollTo(`#${id}`);
    };

    return (
        <>
            <header
                className={`fixed inset-x-0 top-0 z-[70] transition-[background-color,border-color,backdrop-filter] duration-500 ${
                    scrolled
                        ? "border-b border-[#E5E0D5] bg-[#FAF8F5]/85 backdrop-blur-md"
                        : "border-b border-transparent bg-transparent"
                }`}
                data-testid="main-nav"
            >
                <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 sm:px-10">
                    <button
                        onClick={() => scrollTo(0)}
                        className="flex items-center gap-3"
                        data-testid="nav-logo"
                        aria-label="Jaqueca Films — ir al inicio"
                    >
                        <img src={LOGO_OVAL} alt="" className="h-10 w-auto" />
                        <span className="font-display text-xl tracking-tight text-[#141312]">
                            jaqueca <span className="text-[#6B1D2F]">films</span>
                        </span>
                    </button>
                    <nav className="hidden items-center gap-8 md:flex" aria-label="Navegación principal">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                onClick={() => go(l.id)}
                                className="group font-mono-jf text-xs uppercase tracking-[0.2em] text-[#524E48] transition-colors duration-300 hover:text-[#6B1D2F]"
                                data-testid={`nav-link-${l.id}`}
                            >
                                <span className="mr-1.5 text-[#6B1D2F]/50">{l.num}</span>
                                {l.label}
                                <span className="block h-px max-w-0 bg-[#6B1D2F] transition-[max-width] duration-300 group-hover:max-w-full" />
                            </button>
                        ))}
                    </nav>
                    <button
                        className="md:hidden text-[#141312]"
                        onClick={() => setOpen(true)}
                        aria-label="Abrir menú"
                        data-testid="nav-menu-open"
                    >
                        <Menu size={24} />
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="fixed inset-0 z-[80] flex flex-col bg-[#141312] px-8 py-6"
                        data-testid="mobile-menu"
                    >
                        <div className="flex items-center justify-between">
                            <span className="flex items-center gap-3">
                                <img src={LOGO_OVAL} alt="" className="h-9 w-auto" />
                                <span className="font-display text-xl text-[#FAF8F5]">
                                    jaqueca <span className="text-[#C98993]">films</span>
                                </span>
                            </span>
                            <button
                                onClick={() => setOpen(false)}
                                aria-label="Cerrar menú"
                                className="text-[#FAF8F5]"
                                data-testid="nav-menu-close"
                            >
                                <X size={26} />
                            </button>
                        </div>
                        <nav className="mt-16 flex flex-col gap-2" aria-label="Menú móvil">
                            {LINKS.map((l, i) => (
                                <motion.button
                                    key={l.id}
                                    initial={{ opacity: 0, x: -24 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.08 + i * 0.07, duration: 0.4 }}
                                    onClick={() => go(l.id)}
                                    className="border-b border-[#FAF8F5]/10 py-5 text-left font-display text-3xl text-[#FAF8F5]"
                                    data-testid={`mobile-nav-link-${l.id}`}
                                >
                                    <span className="mr-4 font-mono-jf text-xs text-[#C98993]">{l.num}</span>
                                    {l.label}
                                </motion.button>
                            ))}
                        </nav>
                        <p className="mt-auto font-mono-jf text-xs uppercase tracking-[0.25em] text-[#FAF8F5]/40">
                            Todo por la ficción.
                        </p>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
